import { getRideApi } from "api";

export const fetchNearbyVehicles = (position, zoomLevel) => ({
    types: ['NEARBY_VEHICLES_REQUEST', 'NEARBY_VEHICLES_SUCCESS', 'NEARBY_VEHICLES_FAILURE'],
    callAPI: () => getRideApi().nearbyVehicles({ lat: position[0], lon: position[1], zoomLevel: zoomLevel })
})